import MainLayout from 'components/Layout/Main'
import { getAppData, setCacheTags, setCanonical } from 'helpers/initializePage'
import CommunityGuidelines from 'screens/communityGuidelines'
import { contentfulMainSiteService } from 'services/contentful'
import getapp from 'services/getapp'
import initializeExperiments from 'services/launchDarkly'

const ROUTE_NAME = 'community_guidelines'

export const getServerSideProps = async ctx => {
  const contentfulService = contentfulMainSiteService({
    preview: ctx.query.preview,
    environment: ctx.req?.headers['fe-contentful-env'],
  })
  const getAppService = getapp(ctx.req)

  const [experiments, data, navigationData, user] = await Promise.all([
    initializeExperiments({
      ctx,
      pageType: 'static',
    }),
    contentfulService.getLegalPage('/community_guidelines').catch(() => null),
    contentfulService.getLegalPageMenu().catch(() => null),
    getAppService.getUser().catch(() => null),
  ])
  const appData = { ...getAppData(ctx), experiments }
  setCanonical(ctx)

  ctx.req.APP_DATA = appData
  setCacheTags(ctx, 'static')

  return {
    props: {
      data,
      navigationData,
      appData: {
        ...appData,
        user,
        route: ROUTE_NAME,
      },
    },
  }
}

CommunityGuidelines.Layout = MainLayout

export default CommunityGuidelines
